import React from 'react';
import ProfileEdit from '../components/myTrack/profile/ProfileEdit';

const ProfilePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#fff8f5] to-[#EDE4DA]">
      <div className="p-6 lg:p-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#2a2e30] mb-2">Profile</h1>
          <div className="w-24 h-1 bg-[#FF5733] mx-auto rounded-full mb-4"></div>
          <p className="text-lg text-[#2a2e30] opacity-80">
            Manage your account details and profile picture
          </p>
        </div>
      </div>

      <div className="w-full max-w-7xl mx-auto px-2 sm:px-4 pb-8">
        <ProfileEdit />
      </div>
    </div>
  );
};

export default ProfilePage;
